import axios from 'axios';

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const queryStringFix = obj => {
  let result = [];
  Object.keys(obj).forEach(key => {
    let val = obj[key];
    if (val instanceof Array && ['string', 'number'].includes(typeof val[0])) {
      val.forEach(item => {
        result.push(`${key}[]=${encodeURIComponent(item)}`);
      });
    } else {
      result.push(`${key}=${encodeURIComponent(val)}`);
    }
  });
  return result.join('&');
};


axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

axios.interceptors.request.use(function (config) {
  let params = config.params;
  config.params = Object.assign({}, params);
  if (config.method.toUpperCase() === 'POST' && config.headers.post['Content-Type'] === 'application/x-www-form-urlencoded') {
    if (!(config.data instanceof FormData)) {
      config.data = queryStringFix(config.data);
    }
  }
  return config;
});

axios.interceptors.response.use(function (response) {
  let config = response.config;
  let res = response.data;
  if (!res.success) {
    if (config.customError) {
      return config.customError(res);
    } else {
      return Promise.reject(res);
    }
  }
  return response.data;
});
export default axios;